module.exports = __webpack_public_path__ + "static/media/assembly13.8e242daf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly13.png
// module id = 2431
// module chunks = 0